<div class="topbar">
  <div>
    <h1>Indstillinger for Partnerabonnementer</h1>
  </div>
</div>
<div class="page__content settings">
  <table mat-table [dataSource]="subscriptionstypes" class="mat-elevation-z0 settings__table">
    <ng-container matColumnDef="partnerName">
      <th mat-header-cell *matHeaderCellDef>Partner</th>
      <td mat-cell *matCellDef="let row">
        {{ row.partnerName }}
      </td>
    </ng-container>
    <ng-container matColumnDef="subscriptionTypeName">
      <th mat-header-cell *matHeaderCellDef>Abonnement</th>
      <td mat-cell *matCellDef="let row">
        {{ row.subscriptionTypeName }}
      </td>
    </ng-container>
    <ng-container matColumnDef="kundesegment">
      <th mat-header-cell *matHeaderCellDef>Kundesegment</th>
      <td mat-cell *matCellDef="let row">
        {{ row.kundesegment }}
      </td>
    </ng-container>
    <ng-container matColumnDef="maxOutput">
      <th mat-header-cell *matHeaderCellDef>Max effekt</th>
      <td mat-cell *matCellDef="let row">
        {{ row.maxOutput }}
      </td>
    </ng-container>
    <ng-container matColumnDef="numberOfOutdoorParts">
      <th mat-header-cell *matHeaderCellDef>Udedele</th>
      <td mat-cell *matCellDef="let row">
        {{ row.numberOfOutdoorParts }}
      </td>
    </ng-container>
    <ng-container matColumnDef="includes24HourService">
      <th mat-header-cell *matHeaderCellDef>Døgnservice</th>
      <td mat-cell *matCellDef="let row">
        {{ row.includes24HourService ? 'Ja' : 'Nej' }}
      </td>
    </ng-container>
    <ng-container matColumnDef="includesFreeService">
      <th mat-header-cell *matHeaderCellDef>Frie tilkald</th>
      <td mat-cell *matCellDef="let row">
        {{ row.includesFreeService ? 'Ja' : 'Nej' }}
      </td>
    </ng-container>
    <ng-container matColumnDef="ourPrice">
      <th mat-header-cell *matHeaderCellDef>OK pris</th>
      <td mat-cell *matCellDef="let row">
        {{ row.ourPrice }}
      </td>
    </ng-container>
    <ng-container matColumnDef="partnerPrice">
      <th mat-header-cell *matHeaderCellDef>Partners pris</th>
      <td mat-cell *matCellDef="let row">
        {{ row.partnerPrice }}
      </td>
    </ng-container>
    <ng-container matColumnDef="partnerSubscriptionTypeId">
      <th mat-header-cell *matHeaderCellDef>Partner Abonnement</th>
      <td mat-cell *matCellDef="let row">
        {{ row.partnerSubscriptionTypeId }}
      </td>
    </ng-container>
    <ng-container matColumnDef="actions">
      <th mat-header-cell class="row-actions" *matHeaderCellDef></th>
      <td mat-cell *matCellDef="let row">
        <div class="hidden-cell">
          @if (canEdit) {
            <button (click)="edit(row)" class="btn-icon blue" aria-label="Rediger abonnementspris" matTooltip="Rediger abonnementspris">
              <mat-icon svgIcon="edit"></mat-icon>
            </button>
          }
          <button (click)="showhistory(row)" class="btn-icon blue" aria-label="Historik" matTooltip="Historik">
            <mat-icon>timeline</mat-icon>
          </button>
        </div>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
  </table>
</div>
<app-history-view [historyView]="historyView"></app-history-view>
